import React from 'react';
import { string } from 'prop-types';
import personPlaceholder from '@alltrails/images/placeholder/person_placeholder.png';
import styles from './styles/styles.module.scss';
import useImage from '../../../../hooks/useImage';

const UserLabel = ({ name, userLink, profileImageUrl, subText }) => {
  const [imageUrl, setImageUrl] = useImage(profileImageUrl, () => personPlaceholder);

  const handleErrorImageLoad = () => {
    setImageUrl(personPlaceholder);
  };

  return (
    <a className={styles.container} href={userLink}>
      <img onError={handleErrorImageLoad} className={styles.profileImage} src={imageUrl} alt={name} />
      <div className={styles.userData}>
        <div className={styles.userName}>{name}</div>
        <div className={styles.subText}>{subText}</div>
      </div>
    </a>
  );
};

UserLabel.propTypes = {
  name: string,
  userLink: string,
  profileImageUrl: string,
  subText: string
};

UserLabel.defaultProps = {
  subText: '',
  name: '',
  userLink: '/',
  profileImageUrl: personPlaceholder
};

export default UserLabel;
